import Image from 'next/image';
import Link from 'next/link';
// import { Link } from 'react-scroll';

interface FeatureWorkScrollItemProps {
  title: string;
  icon: string;
  index: number;
  itemStyle: number;
  href: string;
  lang: string;
  t: any;
  query: string;
}

function FeatureWorkScrollItem({
  title,
  icon,
  index,
  itemStyle,
  href,
  lang,
  t,
  query,
}: FeatureWorkScrollItemProps) {
  return (
    <div
      className={`flex w-full justify-center border-2 ${
        itemStyle === index ? 'border-gray-900' : 'border-gray-300'
      } cursor-pointer rounded-lg text-gray-800 md:rounded-2xl`}
    >
      <Link
        href={`/${lang}${href}#${query}`}
        className="flex w-full items-center justify-center gap-2 py-3 md:flex-col"
      >
        <Image src={icon} alt="section icon" className="h-6 w-6" />
        <p>{t[title]}</p>
      </Link>
    </div>
  );
}

export default FeatureWorkScrollItem;
